<div class="nav_container">
  <ul>
    <div class="mb-4">
      <!-- ***************** PARTENAIRES ***************** -->
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">
        Partenaires
      </li>

      <!-- Classes virtuels -->
      <!-- <li>
        <a [href]="urlClasseVirtuelle" target="_blank" class="nav_item">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 3h20v13H2V3zm7 13v3m-3 1h10M9 16h6" stroke="#E5E8EC" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <rect x="2" y="3" width="20" height="13" rx="1" stroke="#E5E8EC" stroke-width="1.5" fill="none" />
          </svg>
          <span class="ml-3">Classes virtuelles</span>
        </a>
      </li> -->

      <!-- Connexion -->
      <li>
        <a style="cursor: pointer" (click)="showIframe = true" class="nav_item">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3"
              stroke="#E5E8EC"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="ml-3">Connexion</span>
        </a>
      </li>
    </div>
  </ul>
</div>
<app-iframe-modal
  *ngIf="showIframe"
  [iframeUrl]="urlFondAmorcage"
  (closed)="showIframe = false"
/>
